
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

import HeroImage from './images/hero.png';
import FeatureImage from './images/feature.png';
import IconListImage from './images/icon-list.png';
import ItemList from './images/item-list.png';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

function getSteps() {
    return ['Pick what to personalize', 'Select personalized content', 'Review & confirm'];
}

const styles = theme => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing.unit,
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    }
});

const Footer = () =>
    <CardActions>
        <FormControlLabel
            control={
                <Checkbox
                    value="checkedB"
                    color="primary"
                />
            }
            label="Select"
        />
    </CardActions>

class Step2 extends React.Component {
    static propTypes = {
        classes: PropTypes.object,
    };

    state = {
        selected: [],
    };

    render() {
        const { classes } = this.props;
        const steps = getSteps();
        const { selected } = this.state;

        return (
            <Grid container spacing={24}>
                <Grid item xs={6}>
                    <Card style={{ cursor: 'pointer' }}>
                        <CardMedia
                            style={{
                                height: 0,
                                paddingTop: '56.25%',
                            }}
                            image={HeroImage}
                            title="component"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="headline" component="h2">
                                Hero spot
                            </Typography>
                        </CardContent>
                        <Footer />
                    </Card>
                </Grid>
                <Grid item xs={6}>
                    <Card style={{ cursor: 'pointer' }}>
                        <CardMedia
                            style={{
                                height: 0,
                                paddingTop: '56.25%',
                            }}
                            image={FeatureImage}
                            title="component"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="headline" component="h2">
                                Feature spot
                            </Typography>
                        </CardContent>
                        <Footer />
                    </Card>
                </Grid>
                {/* <Grid item xs={6}>
                    <Card style={{ cursor: 'pointer' }}>
                        <CardMedia
                            style={{
                                height: 0,
                                paddingTop: '56.25%',
                            }}
                            image={IconListImage}
                            title="component"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="headline" component="h2">
                                Icon List spot
                            </Typography>
                        </CardContent>
                        <Footer />
                    </Card>
                </Grid>
                <Grid item xs={6}>
                    <Card style={{ cursor: 'pointer' }}>
                        <CardMedia
                            style={{
                                height: 0,
                                paddingTop: '56.25%',
                            }}
                            image={ItemList}
                            title="component"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="headline" component="h2">
                                Item List spot
                            </Typography>
                        </CardContent>
                        <Footer />
                    </Card>
                </Grid> */}
            </Grid>
        );
    }
}

export default withStyles(styles)(Step2);


// WEBPACK FOOTER //
// ./src/components/personalization/Step2.js